import { DeepReadonly } from '@src/utils/type-utils';
import React, { memo } from 'react';
import { BadgesIconListFragment } from '@graphqlTypes/sitecore';
import classNames from 'classnames';

type Props = {
    badges: DeepReadonly<BadgesIconListFragment | undefined>[];
    className?: string;
};

const KolBadgeList = ({ badges, className }: Props) => {
    return (
        <div
            className={
                className ||
                classNames('leading-[14px]', {
                    'inline-block ml-[2px] align-top px-px': badges.length === 1,
                })
            }
        >
            {badges.map((badge, i) => {
                return (
                    <img
                        className='w-[14px] h-[14px] mr-[2px]'
                        src={badge?.badgeIconImage?.src}
                        alt=''
                        loading='lazy'
                        key={i}
                    />
                );
            })}
        </div>
    );
};

export default memo(KolBadgeList);
